export enum LevelsType {
  cashbackOnly = 'cashbackOnly',
  cashbackAndBenefits = 'cashbackAndBenefits',
}
